import { render, staticRenderFns } from "./FavoriteItem.vue?vue&type=template&id=6e17fd8e&scoped=true&"
import script from "./FavoriteItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteItem.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteItem.vue?vue&type=style&index=0&id=6e17fd8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17fd8e",
  null
  
)

export default component.exports